import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./customizeSpotTheme.css";
import { fetchThemeData } from "../../themeSlice";
import { selectAdminToken } from "../../sessionSlice";
import BadgeCategoryEditor from "./BadgeCategoryEditor";

const CustomizeSpotTheme = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminToken = useSelector(selectAdminToken);
  const { currentTheme, data } = useSelector((s) => s.theme);

  useEffect(() => {
    if (currentTheme) dispatch(fetchThemeData({ themeId: currentTheme }));
  }, [dispatch, currentTheme]);

  return (
    <>
      <div className="back-button-holder">
        <button
          type="button"
          className="back-button"
          onClick={() => navigate("/admin/rules")}
        >
          <i className="fa-solid fa-arrow-left" /> Back
        </button>
      </div>
      <div className="catmgr-page">
        <BadgeCategoryEditor
          data={data}
          currentTheme={currentTheme}
          adminToken={adminToken}
        />
      </div>
    </>
  );
};

export default CustomizeSpotTheme;
